import { render, staticRenderFns } from "./NotFound404View.vue?vue&type=template&id=0effa3a4&scoped=true"
import script from "./NotFound404View.vue?vue&type=script&lang=js"
export * from "./NotFound404View.vue?vue&type=script&lang=js"
import style0 from "./NotFound404View.vue?vue&type=style&index=0&id=0effa3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0effa3a4",
  null
  
)

export default component.exports